<div [attr.data-test]="containerTestSelector()">
  <mwe-card-selectable (changed)="onProductSelect($event)" [isSelected]="isOrdered()" [disabled]="isDisabled()" [readonly]="isReadonly()">
    <mwe-product-icons [categories]="[product().category]" size="xl" textNodeType="p" />

    @if (showTariffClasses()) {
      <div class="mt-1" [innerHTML]="fakeProductForTariffClassTranslations() | translateTariffClass | async"></div>
    }

    @if (showNumber() && number()) {
      <div class="mt-1" [innerHTML]="numberText() | translate: number()"></div>
    }

    <div class="mt-1 text--legal">
      {{ product().category | correlatedCompanyReference }}
    </div>

    @if (showRecommendation()) {
      <div class="mt-3">
        <mwe-badge text="global.badge.recommended" type="info" emphasis="bold" size="sm" iconClass="fa fa-info-circle" />
      </div>
    }
  </mwe-card-selectable>

  @if (showFiberglassInfo()) {
    <div class="row gx-1 font-size-12 text-neutral-600 mt-1">
      <div class="col-auto"><i aria-hidden="true" class="fa fa-info-circle"></i></div>
      <div class="col">
        <span>{{ 'newClient.internet.fiberglassInformation' | translate }}</span>
      </div>
    </div>
  }

  @if (showTVInfoText()) {
    <div class="row gx-1 font-size-12 text-neutral-600 mt-1">
      <div class="col-auto"><i aria-hidden="true" class="fa fa-info-circle"></i></div>
      <div class="col">
        <span>{{ 'newClient.information' | translate }}</span>
      </div>
    </div>
  }

  @if (showInformationText()) {
    <div class="row gx-1 font-size-12 text-neutral-600 mt-1">
      <div class="col-auto"><i aria-hidden="true" class="fa fa-info-circle"></i></div>
      <div class="col">
        <span>{{ 'relocation.information' | translate: { category: informationTextProductCategory() } }}</span>
      </div>
    </div>
  }
</div>
